<template>
    <div v-if="!isLoading" class="view-knowledge-test">
        <page-header
            :headroom-disabled="true"
        ></page-header>

        <knowledge-test
            v-if="!isPreview"
            :interactions="getInteractions"
            :maximum-interactions="getMaximumInteractions"
            :completion-percentage="getCompletionPercentage"
            :conclusion="getConclusion"
            :start-screen="getStartScreen" />

        <knowledge-test-preview
            v-if="isPreview"
            :interactions="getInteractions"
            :conclusion="getConclusion"
            :start-screen="getStartScreen" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
    KNOWLEDGE_TEST_FETCH_NS,
    KNOWLEDGE_TEST_SET_NS
} from "@/store/actions.type";

import PageHeader from '@/components/common/PageHeader.vue';
import KnowledgeTest from '@/components/elements/quiz/KnowledgeTest.vue';
import KnowledgeTestPreview from '@/components/preview/KnowledgeTestPreview.vue';

export default {
    name: 'KnowledgeTestView',
    components: {
        PageHeader,
        KnowledgeTest,
        KnowledgeTestPreview,
    },
    props: {
        content: Object,
        isPreview: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
        }
    },
    computed: {

        ...mapGetters('header', {
            getHeaderHeight: 'getHeight',
        }),

        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),

        ...mapGetters('knowledgeTest', {
            getStartScreen: 'getStartScreen',
            getInteractions: 'getInteractions',
            getMaximumInteractions: 'getMaximumInteractions',
            getCompletionPercentage: 'getCompletionPercentage',
            getConclusion: 'getConclusion',
            isLoadingKnowledgeTest: 'isLoading',
        }),

        isLoading() {
            return this.isLoadingUiTexts || this.isLoadingKnowledgeTest;
        }
    },
    async beforeRouteEnter(to, from, next) {

        await store.dispatch(UITEXTS_FETCH_NS);
        await store.dispatch(KNOWLEDGE_TEST_FETCH_NS, to.params.slug);

        return next();
    },
    async created() {
        if (this.content) {
            store.dispatch(KNOWLEDGE_TEST_SET_NS, this.content);
            await store.dispatch(UITEXTS_FETCH_NS);
        }
    },

    methods: {

    },
}
</script>
